export default __webpack_public_path__ + "static/media/china.09a74fe5.svg";